import { VndlyAlert } from '../../common/VndlyAlert'

export const SOW_VIEW_BASE = '/sow/'
export const SOW_BASE_URL = '/api/v2/sow-module/'
export const BASE_URL = `${SOW_BASE_URL}sow/`
// TODO: We have to update the constant name as this is real base

export const handleExceptions = ({ status, text }) => {
  switch (status) {
    case '409':
      VndlyAlert.confirm.acknowledgment.fire({
        title: undefined,
        text
      })
      break
    default: {
      VndlyAlert.unexpectedError.fire()
    }
  }
}

export const handleFieldExceptions = e => {
  const errorFields = typeof e.body === 'object' && e.body !== null ? Object.keys(e.body) : []
  if (errorFields.length) {
    return VndlyAlert.confirm.acknowledgment.fire({
      title: undefined,
      text: e.body[errorFields[0]]
    })
  }
  return VndlyAlert.unexpectedError.fire()
}
